import styled from "styled-components";

export const CurrencySelector = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  margin: 0 -6px;

`;

export const CurrencyOption = styled.label`
  display: flex;
  align-items: center;
  margin: 0 10px;

  @media (max-width: 600px) {
    margin: 5px 0;
  }
`;

export const RadioButton = styled.input.attrs({ type: "radio" })`
  margin-right: 5px;
`;

export const CurrencyName = styled.span`
  margin-left: 5px;
`;

export const Flag = styled.div`
  width: 20px;
  height: 20px;
  svg {
    width: 20px;
    height: 20px;
  }
`;
